import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsPhoneConfigurationRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-phone-configuration',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/phone',
	exact: true,
};
